export const DEALER_PORTAL_TITLE = 'Dealer Portal';
export const CONSUMER_PORTAL_TITLE = 'Consumer Portal';
